module.exports = __webpack_public_path__ + "img/庆祖镇.70ace7dc.png";